/**
 * Downloads or opens a PDF blob in a way that works across all platforms,
 * including iOS Safari which doesn't support programmatic <a>.click() with
 * blob: URLs.
 *
 * @param {Blob} blob - The PDF blob received from the server
 * @param {string} filename - Suggested filename for the download
 */
export const downloadPdfBlob = (blob, filename = "agreement.pdf") => {
    const url = window.URL.createObjectURL(blob);

    // iOS Safari detection — includes iPad on iOS 13+ (which reports as Mac)
    const ua = navigator.userAgent || "";
    const isIOS =
        /iPad|iPhone|iPod/.test(ua) ||
        (ua.includes("Mac") && "ontouchend" in document);

    if (isIOS) {
        // iOS Safari cannot trigger blob downloads via programmatic <a> clicks.
        // Opening the blob URL in a new window/tab is the only reliable option —
        // Safari will display the PDF inline and the user can use the share
        // sheet to save it to Files if needed.
        window.open(url, "_blank", "noopener,noreferrer");

        // Delay the revoke so Safari has time to load the resource before
        // the URL is invalidated.
        setTimeout(() => window.URL.revokeObjectURL(url), 10000);
    } else {
        // Standard approach for Android, Windows, macOS browsers.
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.rel = "noopener noreferrer";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }
};
